import { render, staticRenderFns } from "./diff.vue?vue&type=template&id=5d37c366&scoped=true"
import script from "./diff.vue?vue&type=script&lang=js"
export * from "./diff.vue?vue&type=script&lang=js"
import style1 from "./diff.vue?vue&type=style&index=1&id=5d37c366&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37c366",
  null
  
)

export default component.exports